import { onMounted, onBeforeUnmount } from "vue";
import { createPlayerInteractionController } from "./playerInteraction.controller";

export function usePipController({
    videoPlayer,
    playerWrapper,
    feedback
}) {
    const playerInteraction =
        createPlayerInteractionController({
            videoPlayer,
            playerWrapper,
            feedback,

            seekSeconds: 3,
            volumeStep: 0.05,

            isBlocked: () => {
                return !!document.querySelector(
                    ".zipImageViewer"
                );
            }
        });

    onMounted(() => {
        playerInteraction.init();
    });

    onBeforeUnmount(() => {
        playerInteraction.destroy();
    });

    return {
        playerInteraction
    };
}